export function currency (input) {
  return Number(Number(input).toFixed(0))
    .toLocaleString()
    .split(/\s/)
    .join(',')
}

export function currencyRupiah (input) {
  return (
    'Rp' +
    Number(Number(input).toFixed(0))
      .toLocaleString()
      .split(',')
      .join('.')
  )
}
